/* =======================================
   SETTINGS FOR ATUM EXPORT PRO
   ======================================= */

import Settings from '../../../../../atum-stock-manager-for-woocommerce/assets/js/src/config/_settings';

export default class ExportSettings extends Settings {
	
	constructor(
		varName: string,
		defaults: any = {}
	) {
		super(varName, defaults);
	}
	
}


// WEBPACK FOOTER //
// ./assets/js/src/config/_export-settings.ts